import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpEvent,
  HttpRequest,
  HttpHandler,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiCallsInProgress } from '../services/api-calls-in-progress.service';
import { environment } from '@admin-env/environment';
import { finalize } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class MyHttpInterceptor implements HttpInterceptor {
  constructor(private apiCalls: ApiCallsInProgress) {}

  intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (httpRequest.url.includes(environment.BASE_PATH)) {
      this.apiCalls.addCall();
    }
    return next.handle(httpRequest).pipe(
      finalize(() => {
        if (httpRequest.url?.includes(environment.BASE_PATH)) {
          this.apiCalls.subtractCall();
        }
      })
    );
  }
}
